import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { PROJECT_TABS } from './constants';

// todo(): use defineMessage
export const CREATIVE_GROUPS = {
  THIS_WEEK: {
    key: 0,
    label: (
      <FormattedMessage
        defaultMessage='This Week'
        description='Label - For projects made in the current week'
      />
    ),
  },
  LAST_WEEK: {
    key: 1,
    label: (
      <FormattedMessage
        defaultMessage='Last Week'
        description='Label - For projects made in the previous week'
      />
    ),
  },
  THIS_MONTH: {
    key: 2,
    label: (
      <FormattedMessage
        defaultMessage='This Month'
        description='Label - For projects made this month'
      />
    ),
  },
  LAST_MONTH: {
    key: 3,
    label: (
      <FormattedMessage
        defaultMessage='Last Month'
        description='Label - For projects made in the previous month'
      />
    ),
  },
};

/* eslint-disable react/jsx-key*/
export const MONTH_MESSAGES = [
  <FormattedMessage
    defaultMessage='January'
    description='Label - For projects made in January'
  />,
  <FormattedMessage
    defaultMessage='February'
    description='Label - For projects made in February'
  />,
  <FormattedMessage
    defaultMessage='March'
    description='Label - For projects made in March'
  />,
  <FormattedMessage
    defaultMessage='April'
    description='Label - For projects made in April'
  />,
  <FormattedMessage
    defaultMessage='May'
    description='Label - For projects made in May'
  />,
  <FormattedMessage
    defaultMessage='June'
    description='Label - For projects made in June'
  />,
  <FormattedMessage
    defaultMessage='July'
    description='Label - For projects made in July'
  />,
  <FormattedMessage
    defaultMessage='August'
    description='Label - For projects made in August'
  />,
  <FormattedMessage
    defaultMessage='September'
    description='Label - For projects made in September'
  />,
  <FormattedMessage
    defaultMessage='October'
    description='Label - For projects made in October'
  />,
  <FormattedMessage
    defaultMessage='November'
    description='Label - For projects made in November'
  />,
  <FormattedMessage
    defaultMessage='December'
    description='Label - For projects made in December'
  />,
];
/* eslint-enable react/jsx-key*/

export const PROJECT_TAB_LABELS = defineMessages({
  [PROJECT_TABS.GLOBAL_TEMPLATES]: {
    defaultMessage: 'Global Templates',
    description: 'Label - for templates available to all users',
  },
  [PROJECT_TABS.PROJECTS]: {
    defaultMessage: 'Projects',
    description: 'Label - for the customers projects',
  },
  [PROJECT_TABS.TEMPLATES]: {
    defaultMessage: 'Templates',
    description: 'Label - for the customers template',
  },
});
